import { writable } from "svelte/store";
import type { SharedAccountState } from "../interfaces/SharedAccount";

export const initialSharedAccountState: SharedAccountState = {
  accountId: null,
  name: null,
  sessionToken: null,
  isRequired: false,
  isUnlocked: false,
  isPromptOpen: false,
  unlockedAt: null,
};

export const sharedAccountState = writable<SharedAccountState>(initialSharedAccountState);
